import { message, Modal } from 'hljd'
import { Api } from '../util'
import { observable, action } from 'mobx'
import { getChartLength, getMerchantInfo } from '@util'
import successModal from './TipModal'
import commonApi from '@api/common'
export default class Store {
  //表单字段
  constructor(query) {
    console.log(query)
    const { id } = query
    this.id = id
    if (id) {
      this.getMemberInfo(id)
    }
  }

  getMemberInfo = async id => {
    const { success, data } = await Api.getEmceeMemberDetail({ id })
    if (success) {
      this.avatar = data.avatar
      this.name = data.name
      this.workingAt = data.workingAt
      this.servicePrice = data.servicePrice
      this.servicePriceTip = data.servicePriceTip
        .filter(item => item.checked)
        .map(item => item.id)
      this.des = data.des
      this.realName = data.realName
      this.certify = data.certify
      this.certifyFront = data.certifyFront
      this.certifyBack = data.certifyBack
      this.auditFailedReason = data.auditFailedReason
      this.audtiStatus = data.audtiStatus
    }
  }
  @observable id = ''
  @observable loading = false
  @observable avatar = ''
  @observable name = ''
  @observable workingAt = null
  @observable servicePrice = ''
  @observable servicePriceTip = []
  @observable des = ''
  @observable realName = ''
  @observable certify = ''
  @observable certifyFront = ''
  @observable certifyBack = ''
  @observable auditFailedReason = ''
  @observable audtiStatus = 0

  //获取数据
  @action
  changeField = type => value => {
    this[type] = value
  }

  //上传图片
  @action
  upload = type => async (file, src) => {
    this[type] = await this.getSafeImg(src)
  }
  getSafeImg = async url => {
    const { success, data } = await commonApi.getSafeImg({ url })
    if (success) {
      return data
    }
  }
  //删除图片
  @action
  removeImg = type => () => {
    this[type] = ''
  }
  @action
  clipPic = type => ({ clipUrl }) => {
    this[type] = clipUrl
  }
  @observable bandWord = ''
  checkBanedWord = async value => {
    const { success, data } = await Api.checkBanedWord(value)
    if (success) {
      if (Array.isArray(data) && data.length > 0) {
        this.bandWord = '违规词：' + data.join('，')
      } else {
        this.bandWord = ''
      }
    }
  }
  validation = () => {
    const {
      avatar,
      name,
      workingAt,
      servicePrice,
      des,
      realName,
      certify,
      certifyFront,
      certifyBack,
      bandWord
    } = this
    if (avatar == '') {
      return '请上传头像'
    }

    if (name.trim() === '') {
      return '请输入称呼'
    }

    if (getChartLength(name.trim(), 'ceil') > 4) {
      return '称呼不能超过4个字符'
    }

    if (!workingAt) {
      return '请选择入行时间'
    }
    if (!servicePrice) {
      return '请输入成员价格'
    }

    if (des && des.trim() !== '' && des.trim().length > 100) {
      return '个人简介不能超过100个字'
    }
    if (bandWord) {
      return '个人简介不能包含违规词'
    }
    if (!realName) {
      return '请输入真实姓名'
    }
    if (!certify) {
      return '请输入身份证号'
    }
    if (!certifyFront) {
      return '请上传身份证正面'
    }
    if (!certifyBack) {
      return '请上传身份证反面'
    }

    return 'pass'
  }

  getFormData = () => {
    const msg = this.validation()

    if (msg == 'pass') {
      const {
        avatar,
        name,
        workingAt,
        servicePrice,
        servicePriceTip,
        des,
        realName,
        certify,
        certifyFront,
        certifyBack
      } = this
      const merchantId = getMerchantInfo().id
      return {
        id: this.id,
        merchantId,
        avatar,
        name,
        workingAt,
        servicePrice,
        servicePriceTip,
        des,
        realName,
        certify,
        certifyFront: certifyFront.split('?')[0],
        certifyBack: certifyBack.split('?')[0]
      }
    } else {
      message.warning(msg, 2)
      return false
    }
  }

  updateStoreInfo = async () => {
    await this.checkBanedWord(this.des)
    let params = this.getFormData()

    if (params && !this.loading) {
      this.loading = true
      const { success, data, msg } = await Api.emceeMemberSumbit(params)
      console.log(data)
      this.loading = false
      if (success) {
        !!data && successModal(data)
      } else {
        return Modal.warning({
          title: msg,
          okText: '我知道了'
        })
      }
    }
  }
}
